import { MARQUEE_ITEMS } from "@/data/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0A0F14] py-5 select-none">
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {items.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display font-bold text-xl sm:text-2xl tracking-tight text-slate-600 px-8 uppercase">
              {item}
            </span>
            <span className="w-2 h-2 rotate-45 bg-[#FFFFFF] shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
